import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { recommendations } from '../../../assets/data/recommendations'
import { URL } from '../../../constants'
import { AuthContext } from '../../../store/auth-context'
import styles from './styles.module.css'


const Recommendations = () => {

    const authCtx = useContext(AuthContext)

    const list = recommendations && recommendations.length && recommendations.map(item => {
        return  <li key={item.id} >
                    <a href={item.link} target="_blank" rel="noreferrer" className="d-flex justify-content-between align-items-center">
                        <div className="pe-2">Improve <span>{item.title}</span> by watching the <span>{item.asset}</span> video</div>
                        <i className={`bi bi-chevron-right ${styles.arrowIcon}`}></i>
                    </a>
                </li>
    })

    return (
        <div className={styles.recommendationsContainer}>
            <h4>RECOMMENDATIONS</h4>
            <ul className={`bg-white ${styles.summaryMetrics} container list-unstyled p-3`}>
                {list}
                <Link to={URL.agentToDos} className={styles.allRecommendations}>View All Recommendations</Link>
            </ul>
        </div>
    )
}

export default Recommendations
